import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
/** @typedef {object} RoutesAdminDashboardProps */

/** @typedef {object} RoutesAdminDashboardState */

/**
 * @extends {ShapeComponent<RoutesAdminDashboardProps, RoutesAdminDashboardState>}
 */
class RoutesAdminDashboard extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.dashboard"})

    useAdminLayout()?.setState({
      headerTitle: t(".dashboard")
    })
  }

  render() {
    return (
      <div className="routes--admin--dashboard">
        stub
      </div>
    )
  }
}

export default memo(shapeComponent(RoutesAdminDashboard))
